function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useState } from 'react';
import uuid from 'short-uuid';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { AutoCompleteItemContainerStyled, AutoCompleteItemTextStyled, AutoCompleteStyled as Autocomplete, ChevronIconStyled, PopperStyled, TextFieldStyled } from './styles/AutoCompleteStyled';
import { InputAdornment } from '@mui/material';
import { DangerIcon, LoupeIcon } from '../../@theme/assets/svg/icons';
var _filterOptions = createFilterOptions({
  matchFrom: 'start',
  stringify: function stringify(option) {
    return option.label;
  }
});
var AutoComplete = function AutoComplete(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$notFound = _ref.notFound,
    notFound = _ref$notFound === void 0 ? '' : _ref$notFound,
    options = _ref.options,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showPopUpIcon = _useState4[0],
    setShowPopUpIcon = _useState4[1];
  var filterOptions = React.useCallback(function (options, state) {
    var results = _filterOptions(options, state);
    var inputValue = state.inputValue;
    setShowPopUpIcon(inputValue === '');
    setError(results.length === 0);
    if (inputValue === '') return options;
    return results;
  }, []);
  var endAdornment = React.createElement(InputAdornment, {
    position: "end"
  }, React.createElement(DangerIcon, null));
  var onSelect = function onSelect(event) {
    var selectChangeEvent = event;
    var selectedOptionLabel = selectChangeEvent.target.value;
    if (selectedOptionLabel) setShowPopUpIcon(false);
  };
  return React.createElement(Autocomplete, _extends({
    id: uuid.generate(),
    freeSolo: true,
    options: options,
    onChange: function onChange(_, value) {
      _onChange(value);
    },
    filterOptions: filterOptions,
    getOptionLabel: function getOptionLabel(option) {
      return option.label;
    },
    PopperComponent: PopperStyled,
    sx: {
      maxWidth: 384
    },
    clearOnBlur: false,
    forcePopupIcon: true
  }, showPopUpIcon ? {
    popupIcon: React.createElement(LoupeIcon, null)
  } : {
    popupIcon: React.createElement(React.Fragment, null)
  }, {
    ListboxProps: {
      style: {
        maxHeight: 280,
        overflow: 'auto'
      }
    },
    onSelect: onSelect,
    renderOption: function renderOption(props, option) {
      return React.createElement(AutoCompleteItemContainerStyled, props, React.createElement(AutoCompleteItemTextStyled, null, option.label), React.createElement(ChevronIconStyled, null));
    },
    renderInput: function renderInput(params) {
      return React.createElement(TextFieldStyled, _extends({}, params, {
        label: label,
        error: error,
        helperText: error ? notFound : '',
        size: "small"
      }, error ? {
        InputProps: {
          endAdornment: endAdornment
        }
      } : {}));
    }
  }));
};
export default AutoComplete;